export const SUCCESS = "green"
export const ALERT = "orange"
export const WARNING = "#b300b3"
export const CRITICAL = "red"
export const OUT_OF_RANGE = "#990000"

export default class AbstractNumberValidator{

  construct(){
    this.fieldSchema = undefined
    this.input = undefined
  }

  getValue(){
    throw "Not implemented"
  }

  getFieldValue() {
    throw "Not implemented"
  }

  getFieldInterface() {
    throw "Not implemented"
  }


  matchAndValidate() {
    let validators = this.fieldSchema.options.validators

    for (let validator of validators) {
      let matched = false

      if (!validator.depend && validator.depends != undefined) {
        return this.validate(validator)
      }

      for (let depend of validator.depends) {
        let fieldInterface = this.getFieldInterface(depend.field)
        if (depend.value != this.getFieldValue(fieldInterface)) {
          matched = false
          break;
        }
        matched = true
      }

      if (matched) {
        return this.validate(validator)
      }
    }
    return this.noMatchedValidator();
  }


  validate(validator){
    let value = parseFloat(this.getValue())
    if (this.isCorrectValue(value, validator)) {
      this.input.style.color = SUCCESS
      return
    }

    return this.matchColorOfError(validator, value)

  }

  matchColorOfError(validator, value){
    if(validator.levels.advanced){
      let ranges =validator.levels.ranges

      if(this.checkValueInRanges(ranges.alert, value)){
        return this.input.style.color=ALERT
      }
      if(this.checkValueInRanges(ranges.warning, value)){
        return this.input.style.color=WARNING
      }
      if(this.checkValueInRanges(ranges.critical, value)){
        return this.input.style.color= CRITICAL
      }
    }

    this.input.style.color = OUT_OF_RANGE
  }


  isCorrectValue(value, validator) {
    if (value >= validator.values.min && value <= validator.values.max) {
      return true
    }
    return false
  }

  checkValueInRanges(ranges, value) {
    for (let range of ranges) {
      if (value >= parseFloat(range.from) && value <= parseFloat(range.to)) {
        return true
      }
    }
    return false
  }

  noMatchedValidator() {
    return this.input.style.color = OUT_OF_RANGE
  }

}
